<template>
  <div id="app">
    <nav-bar></nav-bar>
    <div class="h-100">
      <router-view/>
    </div>
    
  </div>
</template>

<script>
import NavBar  from './components/NavBar.vue';

const DEFAULT_TITLE = 'Maha Lilah';

export default ({
  components: {
    NavBar,
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
          document.title = to.meta.title || DEFAULT_TITLE;
      }
    },
  }
});

</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  width: 100%;
  background-color: #f8f4ef;
}

body {
  background-color: #f8f4ef;
}

.form-select {
  background-color: #f8f4ef;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

</style>
